import { IDailyComment } from "../../types/api";

export const getDailyCommentQueryFn = (
  date: string,
  type: "INDOOR" | "OUTDOOR" | "REHAB"
) => {
  const query = `
        getDailyComment(date: $date, type: $type) {
            ... on DailyComment {
                __typename
                date
                comment
            }
            ... on Error {
                code
                message
            }
       }
    `;
  const inputs = `$date: String! $type: CommentTypeEnum!`;
  const variables = { date: date, type: type };
  return {
    query,
    inputs,
    variables,
  };
};

export const updateDailyCommentQueryFn = (
  date: string,
  comment: string,
  type: "INDOOR" | "OUTDOOR" | "REHAB"
) => {
  const query = `
            updateDailyComment(input: $input, type: $type) {
                ... on DailyComment {
                    __typename
                    date
                    comment
                }
                ... on Error {
                    code
                    message
                }
            }
        `;
  const inputs = `$input: DailyCommentInput! $type: CommentTypeEnum!`;
  const variables = { input: { date: date, comment: comment }, type: type };
  return {
    query,
    inputs,
    variables,
  };
};

export const createDailyCommentQueryFn = (
  date: string,
  comment: string,
  type: "INDOOR" | "OUTDOOR" | "REHAB"
) => {
  const query = `
            createDailyComment(input:$input type: $type) {
                ... on DailyComment {
                    __typename
                    date
                    comment
                }
                ... on Error {
                    code
                    message
                }
            }
        `;
  const inputs = `$input: DailyCommentInput! $type: CommentTypeEnum!`;
  const variables = { input: { date: date, comment: comment }, type: type };
  return {
    query,
    inputs,
    variables,
  };
};
